import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CommonServices from '../../services/commonServices';
import { Button, Card, Col, Row, Space, Typography } from 'antd';
import './dashboard.scss';
import { useUserAuth } from '../../context/UserContext';
import { usePageTitle } from '../../context/pageTitleContext';
import logoBlue from "../../assets/logo_blu.png";
import { Link } from "react-router";

const {Title} = Typography;

const Dashboard = () => {
    const { t } = useTranslation();
    const { user } = useUserAuth();
        const { setPageTitle } = usePageTitle();
       

    useEffect(() => {
         setPageTitle("Dashboard");
       
    }, []);

    return (

        <Space direction='vertical' className="dashboard">

            <Card size="small" title={""}>
                <Row gutter={16} justify={'center'} >
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} style={{ display: "flex", justifyContent: 'center' }}>
                        <Space direction='vertical' >
                            <Link to={{ pathname: `/` }}><img src={logoBlue} alt="LOGO" width={300} /></Link>
                            <Title level={4} style={{ color: "#002964", textAlign:"center" }}>COM Electrolux</Title>
                        </Space>
                    </Col>               
               </Row>
            </Card>

            {/* <Card size="small" title={""}>
                <Row gutter={16}>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }}>
                        <Card size='small' title="Statistics 1">
                            <Row gutter={16} style={{ margin: 0 }}>

                            </Row>
                        </Card>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }}>
                        <Card size='small' title="Statistics 2">
                            <Row gutter={16} style={{ margin: 0 }}>
                              
                            </Row>
                        </Card>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }}>
                        <Card size='small' title="Statistics 3">
                            <Row gutter={16} style={{ margin: 0 }}>
                              
                            </Row>
                        </Card>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 6 }}>
                        <Card size='small' title="Statistics 4">
                            <Row gutter={16} style={{ margin: 0 }}>
                              
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </Card> */}

        </Space>
    );
}
export default Dashboard;